import React, { useEffect, useState } from "react";
import HeroSection from "../components/home/HeroSection";
import EventStrip from "../components/home/EventStrip";
import LatestEvents from "../components/home/LatestEvents";
import AboutUs from "../components/home/AboutUs";
import Team from "../components/home/Team";
import EventGallery from "../components/home/EventGallery";
import Sponsors from "../components/home/Sponsors";
import API from "../config/axios";
import { api_paths } from "../config/api.paths";

function Home() {
  const [bannerData, setBannerData] = useState(null);
  const [loading, setLoading] = useState(true);

  const [otherDetails, setOtherDetails] = useState({
    aboutUs: null,
    committeeList: null,
    sponsorList: null,
    upcomingEvents: null,
    eventCalendarList: null,
  });

  const fetchBannerData = async () => {
    try {
      const response = await API.get(api_paths.member.HOME.GET_BANNER);
      const data = response.data?.payload?.result?.data || null;
      setBannerData(data);
    } catch (error) {
      console.error("Error fetching banner data:", error);
    }
  };

  const fetchOtherDetails = async () => {
    try {
      const response = await API.get(api_paths.member.HOME.GET_OTHER_DETAILS);

      const aboutUs = response.data?.payload?.result?.aboutUs || null;
      const committeeList =
        response.data?.payload?.result?.committeeList || null;
      const sponsorList = response.data?.payload?.result?.sponsorList || null;
      const upcomingEvents =
        response.data?.payload?.result?.upcomingEvents || null;
      const eventCalendarList =
        response.data?.payload?.result?.eventCalendarList;
      setOtherDetails({
        aboutUs,
        committeeList,
        sponsorList,
        upcomingEvents,
        eventCalendarList,
      });
    } catch (error) {
      console.error("Error fetching other details:", error);
    }
  };

  useEffect(() => {
    const loadHomeData = async () => {
      setLoading(true);
      await Promise.allSettled([fetchBannerData(), fetchOtherDetails()]);
      setLoading(false);
    };

    loadHomeData();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <section>
        <div className="container">
          <HeroSection bannerData={bannerData} loading={loading} />
          {/* {otherDetails.eventCalendarList && ( */}
          <EventStrip calendar={otherDetails.eventCalendarList} />
          {/* )} */}
          <LatestEvents
            nextMonthUpcomingEvents={otherDetails.upcomingEvents}
            loading={loading}
          />
          <AboutUs aboutUs={otherDetails.aboutUs} />
          <Team committeeList={otherDetails.committeeList} />
          {/* <EventGallery eventGalleryList={otherDetails.eventGalleryList} loading={loading}/> */}
          <EventGallery />
          <Sponsors sponsorList={otherDetails.sponsorList} />
        </div>
      </section>
    </>
  );
}

export default Home;
